/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type NavLinkProps } from '@mantine/core';
import { RiReceiptFill, RiUserFill, RiSettings3Fill } from '@remixicon/react';

import i18n from '@fai/friendli-suite/features/i18n';
import Paths from '@fai/friendli-suite/features/routes/paths';

type NavLinkItemProps = NavLinkProps & {
  value: string;
  href: string;
  isVisible: boolean;
};

export const teamOwnerSettingsMenus = (teamId: string): NavLinkItemProps[] => {
  const teamSettingsBasePath = (teamId: string) => Paths.team(teamId).teamSettings;

  return [
    {
      value: 'billing',
      label: i18n.t('layout.billing'),
      href: teamSettingsBasePath(teamId).billing,
      leftSection: <RiReceiptFill size={16} />,
      isVisible: true,
    },
    {
      value: 'members',
      label: i18n.t('layout.members'),
      href: teamSettingsBasePath(teamId).members,
      leftSection: <RiUserFill size={16} />,
      isVisible: true,
    },
    {
      value: 'settings',
      label: i18n.t('layout.team_settings'),
      href: teamSettingsBasePath(teamId).billing,
      leftSection: <RiSettings3Fill size={16} />,
      isVisible: true,
    },
  ];
};
